import React from "react";
import "../../Styles/powerbi-module.css";

const PowerBiEmbed = ({ link, height = "100%", width = "100%" }) => {
  if (!link) return <div>No Power BI link provided.</div>;

  const modifiedLink = link.includes("?")
    ? `${link}&rs:embed=true`
    : `${link}?rs:embed=true`;

  return (
    <iframe
      className="powerbi-module"
      title="Power BI Report"
      width={width}
      height={height}
      src={modifiedLink}
      allowFullScreen={true}
      style={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        height: "90vh",
        padding: "2rem",
      }}
    />
  );
};

export default PowerBiEmbed;
